package com.imobly.imobly.api.dto

sealed class ResponseMessage
